<template>
  <validation-form @on-submit="submitQuestion" class="validation-form">
    <div class="md-layout">
      <div
        class="md-layout-item md-size-100"
        v-if="modalType === type.singleLineText"
      >
        <md-checkbox v-model="question.number_only">{{
          $t("survey.number_only")
        }}</md-checkbox>
      </div>
      <div class="md-layout-item md-size-100 md-layout">
        <label class="text-title md-layout-item md-size-100 p-0 mb-1">
          {{ $t("survey.question_text") }}<span class="text-[#F44336]">*</span>
        </label>
        <div class="md-layout-item md-size-100 p-0">
          <validation-field
            class="w-full"
            :validations="{ required: true }"
            name="Question text"
            style="margin-bottom: 0px !important"
            type="autocomplete"
          >
            <template #default="{ errors }">
              <Editor
                class="md-layout w-full"
                v-model="question.question"
                :api-key="EDITOR_API_KEY"
                :init="initEditor"
              ></Editor>
              <span class="question-required">{{ errors[0] }}</span>
            </template>
          </validation-field>
        </div>
      </div>
      <div class="md-layout-item md-size-100 mt-4">
        <label class="text-title">{{ $t("survey.question_subtext") }}</label>
        <div class="border border-gray-300 p-2">
          <md-field>
            <md-textarea class="p-0" v-model="question.subText"></md-textarea>
          </md-field>
        </div>
      </div>
      <div class="md-layout-item md-size-100 mt-4">
        <md-checkbox v-model="question.require">{{
          $t("survey.make_question_required")
        }}</md-checkbox>
      </div>
      <div class="md-layout-item md-size-100 mt-4" v-if="hasChoice">
        <div class="md-layout-item md-size-100 text-title">
          {{ $t("survey.answer_choices") }}
        </div>
        <div class="md-layout-item md-size-100 md-layout">
          <div
            class="md-layout-item md-size-100 md-layout p-0"
            v-for="(choice, index) in question.choices"
            :key="index + 'choice'"
          >
            <div class="md-layout-item md-size-40 p-0">
              <validation-field
                :validations="{ required: true }"
                :name="'text ' + index"
              >
                <label>{{ $t("survey.text") }}</label>
                <md-input
                  required
                  type="text"
                  v-model.trim="choice.text"
                  autocomplete="off"
                ></md-input>
              </validation-field>
            </div>
            <div class="md-layout-item md-size-20 flex">
              <md-radio
                class="my-auto"
                v-model="question.defaultChoice"
                :value="index"
              >
                <span class="text-gray-800">{{ $t("survey.default") }}</span>
              </md-radio>
            </div>
            <div
              class="md-layout-item md-size-10 flex"
              v-if="index !== 0"
              @click="removeChoice(index)"
            >
              <md-icon class="icon-delete text-red-600 my-auto">delete</md-icon>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-size-100">
          <span
            @click="addChoice"
            class="text-[#345FB4] cursor-pointer underline"
            >{{ $t("survey.add_choice") }}</span
          >
        </div>
      </div>
      <div class="md-layout-item md-size-100 mt-10">
        <div class="form-actions text-right">
          <md-button class="md-raised" @click="closeModal">{{
            $t("common.cancel")
          }}</md-button>
          <md-button type="submit" class="md-success ml-4">{{
            mode === "edit" ? $t("common.update") : $t("common.add")
          }}</md-button>
        </div>
      </div>
    </div>
  </validation-form>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import Editor from "@tinymce/tinymce-vue";
import {
  EDITOR_API_KEY,
  EDITOR_PLUGINS,
  EDITOR_TOOLBAR
} from "../../TaskManagement/Component/utils";
export default {
  props: ["modalName", "modalType", "data", "mode"],
  components: {
    Editor
  },
  data() {
    const type = {
      dropdown: "drop_down_list",
      radio: "radio_button",
      checkbox: "checkbox",
      singleLineText: "single_line_text",
      multiLineText: "multi_line_text"
    };
    return {
      EDITOR_API_KEY,
      initEditor: {
        height: 200,
        menubar: true,
        plugins: EDITOR_PLUGINS,
        toolbar: EDITOR_TOOLBAR
      },
      type,
      question: {
        type: "",
        question: "",
        subtext: "",
        require: false,
        choices: [],
        defaultChoice: -1,
        number_only: false,
        defaultValue: ""
      }
    };
  },
  created() {
    this.question.type = this.modalType;
    if (this.mode === "edit") {
      this.question = cloneDeep(this.data);
    }
    if (this.hasChoice && this.mode !== "edit") {
      this.addChoice();
    }
  },
  computed: {
    hasChoice() {
      return (
        this.modalType === this.type.dropdown ||
        this.modalType === this.type.radio ||
        this.modalType === this.type.checkbox
      );
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.modalName);
    },
    submitQuestion() {
      if (this.modalType === this.type.checkbox) {
        this.question.defaultValue = [];
      }
      if (this.mode === "edit") {
        this.$emit("editQuestion", this.question);
        this.$modal.hide(this.modalName);
      } else {
        this.$emit("addQuestion", this.question);
        this.$modal.hide(this.modalName);
      }
    },
    addChoice() {
      this.question.choices.push({ text: "" });
    },
    removeChoice(index) {
      this.question.choices.splice(index, 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.text-title {
  font-size: 14px;
  line-height: 17px;
  color: #242424;
}
.question-required {
  color: #ff1744;
  font-size: 12px;
  position: relative;
}
</style>
